import React, { useState } from 'react';
import styled from '@emotion/styled';
import { useCRMContext } from '../CRMContext';
import { Link } from 'react-router-dom';
import { Box, Typography, Menu, MenuItem, IconButton } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';

interface Props {
  current: string;
  title: string;
}

const Items = [
  { key: "contacts", path: "", label: "Контакты" },
  { key: "organizations", path: "/organization", label: "Компании" },
  { key: "tags", path: "/tag", label: "Теги" },
  { key: "settings", path: "/settings", label: "Настройки" },
];

export const CRMMenu = (props: Props) => {
  const ctx = useCRMContext();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      {/* Clickable Header Area */}
      <HeaderContainer onClick={handleClick}>
        <IconButton size="small" edge="start" sx={{ p: 0.5, mr: 0.5 }}>
          <MenuIcon fontSize="small" />
        </IconButton>
        <Typography variant="h4" sx={{ cursor: 'pointer' }}>
          {props.title}
        </Typography>
      </HeaderContainer>

      {/* Dropdown Menu */}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {Items.map(item => (
          <MenuItem 
            key={item.key} 
            onClick={handleClose} 
            selected={item.key === props.current}
            component={Link}
            to={`${ctx.pagePath}${item.path}`}
            sx={{
              color: 'text.primary',
              textDecoration: 'none'
            }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

// Styled container to group icon and title, making both clickable
const HeaderContainer = styled(Box)`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  border-radius: 4px;
  padding: 4px 8px;
  margin-left: -8px; /* Offset the padding to align with standard text */
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;